import { PublicMeetingSummaryPage } from '@/pages/meeting-summary-public/PublicMeetingSummaryPage';
import { APP_LANGUAGES } from '@/stores/global.store';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

// Public, unauthenticated route reached only from the token link in the summary SMS. It sits outside
// the `_authenticated` tree, following the `/offer/$token` pattern.
const searchSchema = z.object({
	lang: z.enum(APP_LANGUAGES).optional(),
});

export const Route = createFileRoute('/meeting-summary/$token')({
	validateSearch: searchSchema,
	component: PublicMeetingSummaryPage,
});
